import { Link } from "react-router-dom";

function Class({ text, image}) {
    return (
        <div style={({textDecoration: "none", color: "inherit", display: "block"})}>
            <div className="class" style={({display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px"})}>
                <div style={({display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", border: "2px solid rgb(250,250,250)", borderRadius: "60px"})}>
                <img src={image} alt="Ikona"/>
                </div>
                <span style={({color: "rgb(250,250,250)", whiteSpace: "pre-line", textAlign: "center"})}>{text}</span>
            </div>
        </div>
    );
  }
  
  export default Class;